import React, { CSSProperties } from 'react';
import { logoEComicSP_W, sample01img, sample02img, sample03img } from "../../model/DataConst";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider, { CustomArrowProps } from "react-slick";
import styled from "styled-components";
import "./CarouselECS.scss";
import { OrientationContext } from "../../provider/OrientationProvider";
import { MAX_WIDTH } from "../../model/Const";
import { IUADevice, userAgentInfo } from "../../model/UserAgentInfo";

const CarouselParentDiv = styled.div`
	overflow: hidden;
	width: 100%;
	
	*:focus {
	  outline: none;
	}
`;

const CarouselImgParent = styled.div`
    width: calc(100% - 4vmin);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 0 2vmin;
    position: relative;
    
	&.max {
		height: auto !important;
	}
`;

const CarouselImg = styled.img`
	height: 100%;
	width:100%;
	object-fit: contain;
	margin: 0 auto;
`;

const ImgTitleDiv = styled.div`
	padding: 2% 0;
	text-align: center;
	width:100%;
	position: absolute;
	font-size: 4vmin;
	background-color: rgb(89, 87, 87);
	color: white;
	font-weight: bold;
	bottom: 0;
	font-family: "nicomoji";
	
	&.max {
		font-size: 2rem;
	}
`;

const ArrowBase = styled.div`
	width: 10vmin;
	height: 10vmin;
	z-index: 1;
	font-size: 0;
    line-height: 0;
    position: absolute;
    top: 50%;
    display: block;
    padding: 0;
    transform: translate(0, -50%);
    cursor: pointer;
    color: transparent;
    border: none;
    outline: none;
    
	&:before {
		content: "";
		border: solid transparent;
		border-width: 5vmin;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
	}
	
	&.max {
		width: 60px;
		height: 60px;
	}
	
	&.max:before {
		border-width: 30px;
	}
`;

const PrevArrowDiv = styled( ArrowBase )`
	left: 0;

	&:before {
		border-right-color: rgba(223, 0, 58, .7);
		left: -40%;
	}
`;

const NextArrowDiv = styled( ArrowBase )`
	right: 0;

	&:before {
		border-left-color: rgba(223, 0, 58, .7);
		right: -40%;
	}
`;

interface ICarouselHeight {
	imgHeight: CSSProperties;
	// titleStyle: CSSProperties;
}

interface ICustomArrowProps extends CustomArrowProps {
	customClassName?: string;
}

const SamplePrevArrow = ( props: ICustomArrowProps ) => {
	const { onClick, className, customClassName } = props;
	return (
		<PrevArrowDiv
			onClick={onClick}
			className={className + (customClassName ? customClassName : "")}
		/>
	);
};

const SampleNextArrow = ( props: ICustomArrowProps ) => {
	const { onClick, className, customClassName } = props;
	return (
		<NextArrowDiv
			onClick={onClick}
			className={className + (customClassName ? customClassName : "")}
		/>
	);
};

const calcHeightValue = () => {
	// 最大幅より大きく、端末がPCの場合は最大幅で計算
	if ( window.innerWidth > MAX_WIDTH && userAgentInfo.device === IUADevice.pc ) {
		return { height: (MAX_WIDTH - MAX_WIDTH * 0.1) * 0.62 + "px" };
	}

	// 0.62は固定（画像祭の縦横比から計算した値なので）
	return { height: (window.innerWidth - window.innerWidth * 0.1) * 0.62 + "px" };
};

const CarouselECS = React.memo( ( props: {
	centerPadding: string,
	carouselMaxClassName?: string,
} ) => {
	const { centerPadding, carouselMaxClassName } = props;
	const [carouselHeight, setCarouselHeight] = React.useState<ICarouselHeight>( {
		imgHeight: calcHeightValue()
	} );
	const context = React.useContext( OrientationContext );

	React.useEffect( () => {
		setCarouselHeight( {
			imgHeight: calcHeightValue()
		} );

	}, [context.resize] );

	// dotsClass={"carousel-dots" + props.dotsClassName}
	return (
		<CarouselParentDiv>
			<Slider
				dots={true}
				dotsClass={"carousel-dots" + carouselMaxClassName}
				arrows={true}
				autoplay={true}
				autoplaySpeed={6000}
				infinite={true}
				slidesToShow={1}
				slidesToScroll={1}
				swipeToSlide={true}
				centerMode={true}
				centerPadding={centerPadding}
				prevArrow={<SamplePrevArrow customClassName={carouselMaxClassName}/>}
				nextArrow={<SampleNextArrow customClassName={carouselMaxClassName}/>}
			>
				<div>
					<CarouselImgParent
						style={carouselHeight.imgHeight}
						className={carouselMaxClassName}
					>
						<CarouselImg src={sample01img} alt={"よく見る電子コミック"}/>
						<ImgTitleDiv className={carouselMaxClassName}>よく見る電子コミック</ImgTitleDiv>
					</CarouselImgParent>
				</div>
				<div>
					<CarouselImgParent
						style={carouselHeight.imgHeight}
						className={carouselMaxClassName}
					>
						<CarouselImg src={sample02img} alt={"文字や線がくっきりするサイズで作成"}/>
						<ImgTitleDiv className={carouselMaxClassName}>文字や線がくっきりするサイズで作成</ImgTitleDiv>
					</CarouselImgParent>
				</div>
				<div>
					<CarouselImgParent
						style={carouselHeight.imgHeight}
						className={carouselMaxClassName}
					>
						<CarouselImg src={sample03img} alt={"eComicScreen+で作成"}/>
						<ImgTitleDiv
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center"
							}}
							className={carouselMaxClassName}
						><img
							src={logoEComicSP_W}
							alt={"eComicScreen+"}
							style={{
								width: "40%",
								objectFit: "contain"
							}}/> で作成</ImgTitleDiv>
					</CarouselImgParent>
				</div>
			</Slider>
		</CarouselParentDiv>
	);
} );

export default CarouselECS;
